module.exports = __webpack_public_path__ + "static/payment2-68c84c0c049c50f794f23af033345ff0.mp4";